import React, { useEffect } from 'react';
import { AppHeader } from '../components/shared/AppHeader';
import { AppFooter } from '../components/shared/AppFooter';
import ContactSection from '../components/ContactSection/ContactSection';

function Contact() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: "'Montserrat', sans-serif" }}>
      <AppHeader variant="dark" />
      <div style={{ paddingTop: '72px', flex: 1 }}>
        <ContactSection />
      </div>
      <AppFooter variant="dark" />
    </div>
  );
}

export default Contact;
